export const APP_ID = 'com.bitpanda.exchange';

export const APP_CUSTOM_URL_SCHEME = APP_ID;

export const APP_CUSTOM_URL_SCHEME_DEEPLINK = `${APP_ID}.deeplink`;

export const APP_CUSTOM_URL_SCHEME_DEEPLINK_HOST = 'link';
